import ytScriptsInstance from './YTPlayers'

class ProductScripts {
	constructor() {
        if (is_product_page) {
            // Slide Imagens de Produto
            var thumbSlider = new Swiper('.product-thumb-slider', {
                spaceBetween: 10,
                slidesPerView: 5,
                freeMode: false,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
            });
            
            let isAnyVideoPlaying = 'notPlaying';
            var mainSlider = new Swiper('.product-slider', {
                spaceBetween: 10,
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false
                },
                pagination: {
                    el: '.product-gallery .swiper-pagination',
                    type: 'progressbar',
                    clickable: true,
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                thumbs: {
                    swiper: thumbSlider,
                },
                on: {
                    afterInit: (swiper) => {},
                    slideChangeTransitionStart: (swiper) => {
                        // Obter o slide ativo
                        const currentSlide = swiper.slides[swiper.previousIndex];
                        const nextSlide = swiper.slides[swiper.activeIndex];

                        // Verificar se algum vídeo no slide ativo está reproduzindo
                        const videosInActiveSlide = currentSlide.querySelectorAll('.playerYT');

                        videosInActiveSlide.forEach(videoElement => {
                            const playerID = videoElement.id;
                            const player = ytScriptsInstance.players[playerID];
                            
                            if (player && player.getPlayerState() === YT.PlayerState.PLAYING && isAnyVideoPlaying == 'notPlaying') {
                                isAnyVideoPlaying = 'play';
                            }
                        });

                        if (isAnyVideoPlaying == 'play') {
                            // console.log('Video reproduzindo');
                            isAnyVideoPlaying = 'playing';
                            // Pausar o autoplay do slider se um vídeo estiver reproduzindo
                            swiper.autoplay.stop();
                            swiper.slideTo(swiper.previousIndex, 0, false);
                        }
                    },
                    slideChangeTransitionEnd: function (swiper) {
                        isAnyVideoPlaying = 'notPlaying';
                        swiper.autoplay.start();
                        // console.log(isAnyVideoPlaying);

                        const currentSlide = swiper.slides[swiper.previousIndex];
                        const videosInActiveSlide = currentSlide.querySelectorAll('.playerYT');

                        videosInActiveSlide.forEach(videoElement => {
                            const playerID = videoElement.id;
                            const player = ytScriptsInstance.players[playerID];
                            
                            if (player) {
                                player.pauseVideo();
                                ytScriptsInstance.resetPlayerContainer(playerID);
                            }
                        });
                    }
                },
            });

            mainSlider.on('touchEnd', function() {
                if (isAnyVideoPlaying == 'playing') {
                    isAnyVideoPlaying = 'stopPlaying';
                    mainSlider.slideTo(mainSlider.activeIndex);
                }
            });

            document.querySelector('.product-slider .swiper-button-next').addEventListener('click', () => {
                // console.log('Avançando slide');
                if (isAnyVideoPlaying == 'playing') {
                    isAnyVideoPlaying = 'stopPlaying';
                    // mainSlider.allowSlideNext = true;
                    mainSlider.slideTo(mainSlider.activeIndex + 1);
                }
            });
            
            document.querySelector('.product-slider .swiper-button-prev').addEventListener('click', () => {
                // console.log('Voltando slide');
                if (isAnyVideoPlaying == 'playing') {
                    isAnyVideoPlaying = 'stopPlaying';
                    // mainSlider.allowSlideNext = true;
                    mainSlider.slideTo(mainSlider.activeIndex - 1);
                }
            });            

            // Slide Avaliações
            var avaliacaoSlider = new Swiper('.avaliacoes-slider', {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                breakpoints: {
                    640: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 40,
                    },
                    1024: {
                        slidesPerView: 2,
                        spaceBetween: 50,
                    },
                },
            });

            // Funções variações e preços de produto
            jQuery(document).ready(function($) {

                let url = window.location.href;
                let urlParams = new URLSearchParams(window.location.search);

                let commentId = url.split('#comment-')[1];
                if (window.location.href.indexOf("#review-") > -1 || commentId) {
                    console.log('Comentário: ', commentId);
                    $('html').animate({
                        scrollTop: $("#reviews").offset().top - 100
                    }, 100);
                    const commentSlide = $(`.swiper-slide[data-id=${commentId}]`).data('swiper-slide-index');
                    console.log(commentSlide);
                    avaliacaoSlider.slideTo(commentSlide);
                }

                if (urlParams.has('enviar_avaliacao')) {
                    HSOverlay.getInstance('#gaia-form-review', true).element.open();
                }

                $('#commentform #submit').on('click', function () {
                    if ($('#commentform #rating').val() && $('#commentform #comment').val()) {
                        $(this).addClass('loading');
                    } else {
                        $(this).removeClass('loading');
                    }
                });

                // Função para formatar valores monetários
                function formatMoney(amount) {
                    return gaia_currency.format(amount);
                }

                // Função para obter o valor adicional do atributo
                function getAttributePrice(attributeName, attributeValue) {
                    let attributePrice = 0;
                    let term = $('select[name="' + attributeName + '"] option[value="' + attributeValue + '"]');
                    if (term.length) {
                        attributePrice = parseFloat(term.data('attribute-price')) || 0;
                    }
                    return attributePrice;
                }
            
                // Função para atualizar o preço variação do produto
                function updateProductVariationPrice() {
                    return $('.woocommerce-variation.single_variation').hide();

                    // Obter as variações do produto
                    let productVariations = $('.variations_form').data('product_variations');
                    let selectedAttributes = {};
            
                    // Obter os atributos selecionados
                    $('select[name^="attribute_"]').each(function() {
                        selectedAttributes[$(this).data('attribute_name')] = $(this).val();
                    });
            
                    // Encontrar a variação correspondente aos atributos selecionados
                    let matchedVariation = productVariations.find(variation => {
                        return Object.keys(selectedAttributes).every(attribute => {
                            return variation.attributes[attribute] === selectedAttributes[attribute];
                        });
                    });
            
                    if (matchedVariation) {
                        // Obter o preço base da variação
                        let basePrice = parseFloat(matchedVariation.display_price);
                        let regularPrice = parseFloat(matchedVariation.display_regular_price);
            
                        // Adicionar o valor adicional dos atributos
                        let additionalPrice = 0;
                        Object.keys(selectedAttributes).forEach(attribute => {
                            console.log(attribute, selectedAttributes[attribute]);
                            additionalPrice += getAttributePrice(attribute, selectedAttributes[attribute]);
                        });
            
                        let totalPrice = basePrice + additionalPrice;
                        let totalRegularPrice = regularPrice + additionalPrice;
            
                        // Atualizar o HTML do preço
                        let priceHtml = `
                            <div class="gaia_variation_prices min-w-96 max-w-96 placeload loading mb-5" style="">
                                <div class="woocommerce-variation-description"></div>
                                <div class="woocommerce-variation-price flex items-center gap-3">
                                    <div class="woocommerce-variation-intro">
                                        <h3 class="!text-base md:!text-lg text-gray-600 font-normal m-0">Valor final:</h3>
                                    </div>
                                    <span class="price !text-base font-medium md:!text-lg m-0">
                                        <del aria-hidden="true" class="!hidden">
                                            <span class="woocommerce-Price-amount amount">
                                                <bdi>
                                                    <span class="woocommerce-Price-currencySymbol">$</span>${totalRegularPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </bdi>
                                            </span>
                                        </del>
                                        <span class="screen-reader-text">Original price was: $ ${totalRegularPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}.</span>
                                        <ins aria-hidden="true">
                                            <span class="woocommerce-Price-amount amount !text-base md:!text-lg font-medium">
                                                <bdi>
                                                    <span class="woocommerce-Price-currencySymbol">$</span> ${totalPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                </bdi>
                                            </span>
                                        </ins>
                                        <span class="screen-reader-text">Current price is: $ ${totalPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}.</span>
                                    </span>
                                </div>
                                <div class="woocommerce-variation-availability"></div>
                            </div>`;
            
                        $('.woocommerce-variation.single_variation').html(priceHtml);

                        setTimeout(() => {
                            $('.gaia_variation_prices').removeClass('loading');
                        }, 500)
                    }
                }

                // Função para exibir o valor adicional do atributo
                function showAttributePrice() {
                    if (!window.product_variable) { return false; }
                    $('select[name^="attribute_"]').each(function() {
                        let attributeName = $(this).attr('name');
                        let attributeValue = $(this).val();
                        let attributePrice = getAttributePrice(attributeName, attributeValue);

                        // Remover qualquer mensagem de preço adicional existente
                        $(this).next().next('.attribute-price-info').remove();

                        // Adicionar mensagem de preço adicional, se aplicável
                        if (attributePrice > 0) {
                            let priceInfoHtml = `<div class="attribute-price-info text-sm text-primary font-normal my-2 mx-3">+ ${formatMoney(attributePrice)}</div>`;
                            $(this).next().after(priceInfoHtml);
                        }
                    });
                }

                // Função para obter o valor adicional do atributo selecionado
                function getSelectedAttributePrice() {
                    let selectedAttributePrice = 0;
                    $('select[name^="attribute_"]').each(function() {
                        let attributeName = $(this).attr('name');
                        let attributeValue = $(this).val();
                        if (attributeValue) {
                            let term = $(`select[name="${attributeName}"] option[value="${attributeValue}"]`);
                            let additionalPrice = term.data('attribute-price') || 0;
                            selectedAttributePrice += additionalPrice;
                        }
                    });
                    $('input[name^="additional_skus"]:checked').each(function() {
                        let attributeSku = $(this);
                        let attributeSkuValue = $(this).val();
                        if (attributeSkuValue) {
                            let additionalSkuPrice = Number(attributeSku.data('attribute_price')) || 0;
                            selectedAttributePrice += additionalSkuPrice;
                        }
                    });
                    console.log('selectedAttributePrice', selectedAttributePrice);
                    return selectedAttributePrice;
                }

                // Função para obter os preços da variação selecionada
                function getSelectedVariationPrices() {
                    let variations = $('.variations_form.cart').data('product_variations');

                    if (!variations) return null;

                    let selectedAttributes = {};
                    $('select[name^="attribute_"]').each(function() {
                        selectedAttributes[$(this).attr('name')] = $(this).val();
                    });

                    let selectedVariation = variations.find(variation => {
                        return Object.keys(selectedAttributes).every(attr => {
                            return selectedAttributes[attr] === variation.attributes[attr];
                        });
                    });

                    return selectedVariation ? {
                        basePrice: selectedVariation.display_regular_price,
                        salePrice: selectedVariation.display_price,
                        imageUrl: selectedVariation.image.url
                    } : null;
                }

                // Função para atualizar o preço do produto
                function updateProductPriceOnPage() {
                    // Efeito loading
                    $('.precos').addClass('loading');

                    // Obter os preços da variação selecionada
                    let variationPrices = window.product_variable ? getSelectedVariationPrices() : null;

                    // Se não houver uma variação selecionada, usar as variáveis globais
                    let basePrice = variationPrices ? variationPrices.basePrice : window.base_price;
                    let salePrice = variationPrices ? variationPrices.salePrice : window.sale_price;

                    // DESCONTO MANUAL (BLACK FRIDAY)
                    if ( is_desconto_manual && desconto_manual_percent > 0 ) {
                        salePrice = basePrice ? basePrice - (basePrice * (desconto_manual_percent / 100)) : null;
                    }
                    
                    // Obter a porcentagem de desconto e a quantidade de parcelas das variáveis globais
                    let percentDiscount = window.percent_discount || 0;
                    let qtdInstallments = window.qtd_installments || 1;

                    // Obter o valor adicional do atributo selecionado
                    let selectedAttributePrice = getSelectedAttributePrice();

                    // Obter o valor adicional do campo #pe_direito
                    let peDireitoPrice = $('#pe_direito').length ? getPeDireitoPrice($('#pe_direito').val()) : 0;

                    // Calcular o preço final
                    let finalBasePrice = basePrice + selectedAttributePrice + peDireitoPrice;
                    let finalSalePrice = salePrice ? salePrice + selectedAttributePrice + peDireitoPrice : null;

                    // Usar finalBasePrice se finalSalePrice não estiver disponível
                    if (!finalSalePrice) {
                        finalSalePrice = finalBasePrice;
                    }

                    // Obter a quantidade selecionada
                    let quantity = Number($('[name="quantity"]').val()) || 1;

                    // Multiplicar os preços pela quantidade
                    finalBasePrice *= quantity;
                    finalSalePrice *= quantity;

                    // Calcular o preço com desconto e o valor das parcelas
                    let discountPrice = finalSalePrice - (finalSalePrice * (percentDiscount / 100));
                    let installmentPrice = finalSalePrice / qtdInstallments;

                    // console.log(finalBasePrice, finalSalePrice, discountPrice, installmentPrice);

                    // Atualizar os elementos na página com os novos preços e valores calculados
                    $('.precos .de del').text(`${formatMoney(finalBasePrice)}`);
                    $('.precos .a_vista ins').text(`${formatMoney(discountPrice)}`);
                    $('.precos .a_vista .sem_desconto').text(`${formatMoney(finalSalePrice)}`);
                    $('.precos .a_vista .porcentagem_desconto').text(`${percentDiscount}`);
                    $('.precos .a_vista .qtd_parcelas').text(`${qtdInstallments}`);
                    $('.precos .a_vista .condicoes b:last-child').text(`${formatMoney(installmentPrice)}`);

                    // Remover efeito loading
                    setTimeout(() => {
                        $('.precos').removeClass('loading');
                    }, 500);
                }

                // Função para mover o slider para a imagem da variação selecionada
                function updateSwiperToSelectedVariation() {
                    let variationPrices = getSelectedVariationPrices();
                    if (variationPrices && variationPrices.imageUrl) {
                        let imageUrl = variationPrices.imageUrl;
                        let slides = mainSlider.slides;
                        for (let i = 0; i < slides.length; i++) {
                            let slideImage = $(slides[i]).data('image');
                            if (slideImage === imageUrl) {
                                mainSlider.slideTo(i);
                                break;
                            }
                        }
                    }
                }
                
                // Atualizar preços
                $('body').on('change', 'select[name^="attribute_"],input[name="quantity"]', function() {
                    updateProductPriceOnPage();
                    updateProductVariationPrice();
                    showAttributePrice();
                    updateSwiperToSelectedVariation();

                    if ($(this).val() != '') {
                        $(this).removeClass('invalid');
                        if (($('#pe_direito').length && $('#pe_direito').val() == '') || ($('#tamanho').length && $('#tamanho').val() == '')) {
                            if ($('#pe_direito').val() == '') {
                                $('#pe_direito').addClass('invalid');
                            }
                            if ($('#tamanho').val() == '') {
                                $('#tamanho').addClass('invalid');
                            }

                            let attemps = 0;
                            let interval = setInterval(() => {
                                if (attemps == 3) {
                                    clearInterval(interval);
                                }
                                attemps++;

                                $('.single_add_to_cart_button').addClass('disabled');
                                $('.single_add_to_cart_button').addClass('wc-variation-selection-needed');
                                $('.woocommerce-variation-add-to-cart').addClass('woocommerce-variation-add-to-cart-disabled');
                                $('.woocommerce-variation-add-to-cart').removeClass('woocommerce-variation-add-to-cart-enabled');
                            }, 200);
                            
                            // console.log('Tamanhos não preenchido:', $(this));
                        } else if ($('select.atributo_produto').length) {
                            $('#pe_direito').removeClass('invalid');
                            $('#tamanho').removeClass('invalid');
                            $('select.atributo_produto').each(function( index ) {
                                if ($(this).val() == '') {
                                    $(this).addClass('invalid');
                                    $('.single_add_to_cart_button').addClass('disabled');
                                    $('.single_add_to_cart_button').addClass('wc-variation-selection-needed');
                                    $('.woocommerce-variation-add-to-cart').addClass('woocommerce-variation-add-to-cart-disabled');
                                    $('.woocommerce-variation-add-to-cart').removeClass('woocommerce-variation-add-to-cart-enabled');
                                    // alert($(this).find('option:first-child').text());
                                    // return;
                                    // console.log('Variaveis não selecionadas:', $(this));
                                } else {
                                    // console.log('Produto selecionado:', $(this).val());
                                    $(this).removeClass('invalid');
                                    $('.single_add_to_cart_button').removeClass('disabled');
                                    $('.single_add_to_cart_button').removeClass('wc-variation-selection-needed');
                                    $('.woocommerce-variation-add-to-cart').removeClass('woocommerce-variation-add-to-cart-disabled');
                                    $('.woocommerce-variation-add-to-cart').addClass('woocommerce-variation-add-to-cart-enabled');
                                }
                            });
                        }
                    } else {
                        // console.log('Variaveis não selecionadas', $(this));
                        $(this).addClass('invalid');
                        $('.single_add_to_cart_button').addClass('disabled');
                        $('.single_add_to_cart_button').addClass('wc-variation-selection-needed');
                        $('.woocommerce-variation-add-to-cart').addClass('woocommerce-variation-add-to-cart-disabled');
                        $('.woocommerce-variation-add-to-cart').removeClass('woocommerce-variation-add-to-cart-enabled');
                    }
                });

                $('body').on('change', 'input[name^="additional_skus"]', function() {
                    updateProductPriceOnPage();
                    updateProductVariationPrice();
                    // showAttributePrice();

                    $(this).closest('label').toggleClass('checked');
                });

                // Botão comprar
                $(document).on( "click", '.single_add_to_cart_button', function(e) {
                    e.preventDefault();

                    if ($(this).hasClass('wc-variation-selection-needed') && $(this).hasClass('disabled')) {
                        e.stopPropagation();

                        if ($('#pe_direito').length && !$('#pe_direito').val()) {
                            $('#pe_direito').addClass('invalid');
                            // alert('Informe o tamanho de pé direito');
                            // return;
                        } else {
                            $('#pe_direito').removeClass('invalid');
                        }
                        if ($('#tamanho').length && !$('#tamanho').val()) {
                            $('#tamanho').addClass('invalid');
                            // alert('Informe o tamanho');
                            // return;
                        } else {
                            $('#tamanho').removeClass('invalid');
                        }
                        if ($('select.atributo_produto').length) {
                            $('select.atributo_produto').each(function( index ) {
                                // console.log( index + ": " + $(this).val() );
                                if ($(this).val() == '') {
                                    $(this).addClass('invalid');
                                    // alert($(this).find('option:first-child').text());
                                    // return;
                                } else {
                                    $(this).removeClass('invalid');
                                }
                            });
                        }
                    }
                })
            
                // Atualiza o preço ao carregar a página
                updateProductPriceOnPage();
                if (window.product_variable) { 
                    updateProductVariationPrice();
                    showAttributePrice();

                    if( !$('.tamanho_container_field').length && !$('select.atributo_produto').length ) {
                        setTimeout(() => {
                            jQuery('.single_add_to_cart_button').removeClass('disabled');
                            jQuery('.single_add_to_cart_button').removeClass('wc-variation-selection-needed');
                            jQuery('.woocommerce-variation-add-to-cart').removeClass('woocommerce-variation-add-to-cart-disabled');
                            jQuery('.woocommerce-variation-add-to-cart').addClass('woocommerce-variation-add-to-cart-enabled');
                        }, 500);
                    }

                    if( $('.atributo_multiplo_produto').length ) {
                        const produto_padrao = jQuery('input[name="additional_skus[]"]:checked');
                        const produto_padrao_id = produto_padrao.data('variable_id');
                        const produto_padrao_sku = produto_padrao.val();
                        console.log('Produto padrão do kit:', produto_padrao_id);
                        $('.woocommerce-variation-add-to-cart input[name="variation_id"]').val(produto_padrao_id).trigger('change');
                    }
                }

                // Atualizar preços ao alterar o valor do campo #pe_direito
                $('#pe_direito').on('input change', function() {
                    var selecteInputdSize = $(this).val();
                    var selectedSize = Number($(this).val());
                    var selectInfo = $(this).next('.info_tamanho');
                    var requiredInfo = $(this).closest('.pe_direito_container_field').find('.required_tamanho');

                    if (selecteInputdSize.length == 0) {
                        $(this).addClass('invalid');
                        $('.single_add_to_cart_button').addClass('disabled');
                        updateProductPriceOnPage();
                        return;
                    }

                    // if (selecteInputdSize.length < 3) {
                    //     return;
                    // } 

                    if (selectedSize < window.min_pedireito || selectedSize > window.max_pedireito) {
                        const message = t('product.height_range_between', null, { min: window.min_pedireito, max: window.max_pedireito });
                        // alert(message);
                        requiredInfo.removeClass('hidden');
                        requiredInfo.text(message);
                        // $(this).val('');
                        selectInfo.addClass('hidden');
                        selectInfo.find('.margem_uso_01').html('2000');
                        selectInfo.find('.margem_uso_02').html('2100');
                        $('.woocommerce-variation-add-to-cart').removeClass('woocommerce-variation-add-to-cart-enabled');
                        $('.woocommerce-variation-add-to-cart').addClass('woocommerce-variation-add-to-cart-disabled');
                        $('.single_add_to_cart_button').addClass('disabled');
                        $('.single_add_to_cart_button').addClass('wc-variation-selection-needed');
                        // return;
                    } else {

                        requiredInfo.addClass('hidden');

                        if ($('select[name^="attribute_"]') && $('select[name^="attribute_"]').val() == '') {
                            $('.woocommerce-variation-add-to-cart').removeClass('woocommerce-variation-add-to-cart-enabled');
                            $('.woocommerce-variation-add-to-cart').addClass('woocommerce-variation-add-to-cart-disabled');
                            $(this).addClass('invalid');
                            $('.single_add_to_cart_button').addClass('disabled');
                            $('.single_add_to_cart_button').addClass('wc-variation-selection-needed');
                        } else {
                            $(this).removeClass('invalid');
                            $('.single_add_to_cart_button').removeClass('disabled');
                            $('.single_add_to_cart_button').removeClass('wc-variation-selection-needed');
                            $('.woocommerce-variation-add-to-cart').removeClass('woocommerce-variation-add-to-cart-disabled');
                            $('.woocommerce-variation-add-to-cart').addClass('woocommerce-variation-add-to-cart-enabled');
                        }

                        $(this).removeClass('invalid');
                        selectInfo.removeClass('hidden');
                        selectInfo.find('.margem_uso_01').html(selectedSize);
                        selectInfo.find('.margem_uso_02').html(selectedSize+window.ajuste_pedireito);

                        updateProductPriceOnPage();
                    }
                });

                // Validação tamanhos
                $('#tamanho').on('blur', function() {
                    var selecteInputdSize = $(this).val();
                    var selectedSize = Number($(this).val());

                    if (window.min_padrao && selectedSize < window.min_padrao) {
                        if (!window.window.max_padrao) {
                            $(this).addClass('invalid');
                            alert(t('product.size_must_be_at_least', null, { size: window.min_padrao }));
                        } else {
                            $(this).addClass('invalid');
                            alert(t('product.size_must_be_between', null, { min: window.min_padrao, max: window.max_padrao }));
                        }
                        $(this).val('');
                        $('.woocommerce-variation-add-to-cart').removeClass('woocommerce-variation-add-to-cart-enabled');
                        $('.woocommerce-variation-add-to-cart').addClass('woocommerce-variation-add-to-cart-disabled');
                        $('.single_add_to_cart_button').addClass('disabled');
                        $('.single_add_to_cart_button').addClass('wc-variation-selection-needed');
                        return;
                    }

                    if (window.max_padrao && selectedSize > window.window.max_padrao) {
                        alert(t('product.size_must_be_between', null, { min: window.min_padrao, max: window.max_padrao }));
                        $(this).val('');
                        $('.woocommerce-variation-add-to-cart').removeClass('woocommerce-variation-add-to-cart-enabled');
                        $('.woocommerce-variation-add-to-cart').addClass('woocommerce-variation-add-to-cart-disabled');
                        $(this).addClass('invalid');
                        $('.single_add_to_cart_button').addClass('disabled');
                        $('.single_add_to_cart_button').addClass('wc-variation-selection-needed');
                        return;
                    }

                    if ($('select[name^="attribute_"]') && $('select[name^="attribute_"]').val() == '') {
                        $('.woocommerce-variation-add-to-cart').removeClass('woocommerce-variation-add-to-cart-enabled');
                        $('.woocommerce-variation-add-to-cart').addClass('woocommerce-variation-add-to-cart-disabled');
                        $('.single_add_to_cart_button').addClass('disabled');
                        $('.single_add_to_cart_button').addClass('wc-variation-selection-needed');
                    } else {
                        $(this).removeClass('invalid');
                        $('.single_add_to_cart_button').removeClass('disabled');
                        $('.single_add_to_cart_button').removeClass('wc-variation-selection-needed');
                        $('.woocommerce-variation-add-to-cart').removeClass('woocommerce-variation-add-to-cart-disabled');
                        $('.woocommerce-variation-add-to-cart').addClass('woocommerce-variation-add-to-cart-enabled');
                    }
                });


                // Ler mais em avaliações
                $( ".containter_review_text" ).each(function() {
                    if ($(this).height() > 96) {
                        $( this ).addClass( "close" );
                        $( this ).next('.read_more').removeClass( "invisible" );
                    }
                });
                $( ".avaliacao" ).on('click', '.read_more', function(e) {
                    e.preventDefault();
                    $( this ).prev('.containter_review_text').removeClass( "close" );
                    $( this ).prev('.containter_review_text').addClass( "open" );
                    $( this ).addClass( "invisible" );
                    return false;
                });
            });
        }

        // Contador produtos salvos
        jQuery(document).ready(function($) {
            $( document ).on( 'added_to_wishlist removed_from_wishlist', function() {
                $.get( yith_wcwl_l10n.ajax_url, {
                    action: 'yith_wcwl_update_wishlist_count'
                }, function( data ) {
                    // console.log('Produtos salvos:', data.count);
                    if (data.count) {
                        $('.gaia_whishlist_count').removeClass('hidden').html(data.count);
                    } else {
                        $('.gaia_whishlist_count').addClass('hidden');
                    }
                } );
            } );
        });
	}
}

export default ProductScripts